import axios from 'axios'

// Используем относительный путь для production (запросы идут на тот же домен)
// или абсолютный URL для development (если указан VUE_APP_API_URL)
// Если VUE_APP_API_URL не установлена, используем относительный путь
const getApiBaseURL = () => {
  if (process.env.VUE_APP_API_URL) {
    // Если указан явный URL, используем его
    return `${process.env.VUE_APP_API_URL}/api`
  }
  // Иначе используем относительный путь (работает в production)
  return '/api'
}

// Создаем базовый axios инстанс
const api = axios.create({
  // Базовый URL для API запросов
  baseURL: getApiBaseURL(),
  
  // Настройки для получения кастомных заголовков
  withCredentials: true,
})

// Интерцептор для запросов
api.interceptors.request.use(
  (config) => {
    // Здесь можно добавить токен авторизации
    const token = localStorage.getItem('token')
    if (token) {
      config.headers["x-user"] = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Точки входа, которые выдают токен там, где его ещё нет в хранилище.
const AUTH_ENTRY_PATHS = ["/sessions", "/registrations", "/organizations"]

const isAuthEntry = (config) => {
  const url = config?.url || ""
  return AUTH_ENTRY_PATHS.some((path) => url.startsWith(path))
}

// Токен маэстро, возвращённый после протухшего имперс-токена: параллельные
// запросы отвечают 401 пачкой, и хвост этой пачки не должен принять
// восстановленную сессию за протухшую и стереть её.
let restoredToken = null

// Интерцептор для ответов
api.interceptors.response.use(
  (response) => {
    const token = response.headers["x-user"]
    // Продлеваем только живую сессию: ответ, пришедший после выхода или сброса
    // токена гвардом, не должен возвращать удалённый токен в хранилище.
    if (token && (localStorage.getItem("token") || isAuthEntry(response.config))) {
      localStorage.setItem("token", token)
    }
    restoredToken = null
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      const original = localStorage.getItem("original_token")
      if (original) {
        // импер-токен протух — фолбэк на токен Maestro
        localStorage.setItem("token", original)
        localStorage.removeItem("original_token")
        localStorage.removeItem("impersonation_expires_at")
        restoredToken = original
        // редирект делать не будем — фронт получит 401 и пользователь перезагрузит страницу
        // либо banner уже сам инициирует stopImpersonation по таймеру
      } else if (!(restoredToken && localStorage.getItem("token") === restoredToken)) {
        localStorage.removeItem("token")
      }
    }

    // Принудительный опрос /up на 5xx временно отключён вместе с баннером
    // техработ/недоступности (см. App.vue) — вернуть после доработки бизнес-логики.
    // if (error.response?.status >= 500) {
    //   // Бэкенд ответил 5xx — провоцируем опрос /up для детекта техработ/сбоя.
    //   // Ленивый импорт стора, чтобы не создавать циклическую зависимость на этапе модуля.
    //   import("@/store").then(({ default: store }) => {
    //     store.dispatch("system/forcePoll")
    //   })
    // }

    return Promise.reject(error)
  }
)

export default api
